import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DeviceReadingResponse } from '@/domain/Historical/Historical';

dayjs.extend(utc);

interface HistoricalValue {
	v: number | null;  
	s: string | null;  
	q: number | null;  
}


function transformGmtToLocalTimestamp(gmtTimestamp: string): number {

	const gmtMoment = dayjs.utc(parseInt(gmtTimestamp));

	const localMoment = dayjs(gmtMoment.format('YYYY-MM-DD HH:mm:ss'));
	
	return localMoment.valueOf();
}


function transformReadingsTimestamps(readings: Record<string, HistoricalValue>): Record<string, HistoricalValue> {
	const localReadings: Record<string, HistoricalValue> = {};
	
	Object.entries(readings).forEach(([gmtTimestamp, value]) => {
		const localTimestamp = transformGmtToLocalTimestamp(gmtTimestamp);
		localReadings[localTimestamp.toString()] = value;
	});
	
	return localReadings;
}


export function transformHistoricalReadingTimestamps(
	reading: DeviceReadingResponse | null | undefined
): DeviceReadingResponse | null {
	
	if (!reading?.measurementToolHistoricalValues) {
		return reading ?? null;
	}

	
	const historicalValues = reading.measurementToolHistoricalValues as Record<string, HistoricalValue>;
	if (!historicalValues || typeof historicalValues !== 'object') {
		return reading;
	}

	
	const entries = Object.entries(historicalValues);
	if (entries.length === 0) {
		return reading;
	}

	try {
		
		const localReadings = transformReadingsTimestamps(historicalValues);

		return {
			...reading,
			measurementToolHistoricalValues: localReadings,
		};
	} catch (error) {
		console.error('Error transforming timestamps:', error);
	
		return reading;
	}
}

export function transformMultipleHistoricalReadingTimestamps<T extends Record<string, DeviceReadingResponse | null | undefined>>(
	readings: T
): Record<string, DeviceReadingResponse | null> {
	const transformedReadings: Record<string, DeviceReadingResponse | null> = {};
	
	Object.entries(readings).forEach(([key, reading]) => {
		transformedReadings[key] = transformHistoricalReadingTimestamps(reading);
	});
	
	return transformedReadings;
}


export async function transformMultipleHistoricalReadingTimestampsAsync<T extends Record<string, DeviceReadingResponse | null | undefined>>(
	readings: T
): Promise<Record<string, DeviceReadingResponse | null>> {
	return new Promise((resolve) => {
		
		setTimeout(() => {
			const result = transformMultipleHistoricalReadingTimestamps(readings);
			resolve(result);
		}, 0);
	});
}